import { Link } from "react-router-dom";
import logo from "../assets/images/logo-2.png";
import BackToTop from "./Backtotop";
import Newsletter from "./Newsletter";
import { Companydata } from "./companydata";

function Footer() {
  return (
    <>

    <Newsletter/>
    <footer className="rounded3 rounded-bottom-0 pt-10 pb-6">
      
      <div className="container ">
        <div className="footer-inner text-white text-center text-xl-start">

          <div className="footer-body my-7">
            <div className="row ">

              {/* ===== Footer Info ===== */}
              <div className="col-xl-3">
                <div className="footer-info">
                  <div className="footer-logo">
                    <img src={logo} alt="footer logo" className="w-60 mb-2" />
                  </div>

                  <div className="footer-info-inner mb-4">
                    <p className="mb-2">
                      Leading the way in turnkey EV charging deployments and expert HT/LT connectivity.
                    </p>
                    
                  </div>

                  <div className="footer-socials d-flex justify-content-center justify-content-xl-start">
                    <a href="#" className="rounded-circle text-center me-1 bg-lightdark">
                      <i className="fa fa-facebook"></i>
                    </a>
                    <a href="#" className="rounded-circle text-center me-1 bg-lightdark">
                      <i className="fa fa-twitter"></i>
                    </a>
                    <a href="#" className="rounded-circle text-center me-1 bg-lightdark">
                      <i className="fa fa-google-plus"></i>
                    </a>
                    <a href="#" className="rounded-circle text-center bg-lightdark">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>

              {/* ===== Quick Links ===== */}
              <div className="col-xl-2 col-md-6">
                <div className="quick-links ">
                  <h3 className="text-white mb-2">Quick Link</h3>
                  <div className="seperator  w-25 border-bottom border-1 border-white mb-4 ms-xl-1 m-auto"></div>
                  <ul className="list-unstyled  ">
                    <li className="mb-4 text-white"><Link to="/about">About Us</Link></li>
                    <li className="mb-4"><Link to="/services">Services</Link></li>
                   
                    <li className="mb-4"><Link to="/contact">Contact us</Link></li>
                    <li className="mb-4"><Link to="#">Policies</Link></li>
                   
                  </ul>
                </div>
              </div>

              {/* ===== Features ===== */}
              <div className="col-xl-3 col-md-6">
                <div className="quick-links">
                  <h3 className="text-white mb-2">Features</h3>
                  <div className="seperator w-25 border-bottom border-1 border-white mb-4 ms-xl-1 m-auto"></div>
                  <ul className="list-unstyled">
                    <li className="mb-4"><Link to="#">Real-Time Project Tracking</Link></li>
                    <li className="mb-4"><Link to="#">Digital Document Repository</Link></li>
                    <li className="mb-4"><Link to="#">Direct Communication with Subject Matter Experts</Link></li>
                    <li className="mb-4"><Link to="#">Compliance & Safety Dashboard</Link></li>
                    <li className="mb-4"><Link to="#">Onsite Payment</Link></li>
                    <li><Link to="#">Merchant Refund</Link></li>
                  </ul>
                </div>
              </div>

              {/* ===== Contact Info ===== */}
              <div className="col-xl-4">
                <div className="footer-contact">
                  <h3 className="text-white mb-2">Contact Info</h3>
                  <div className="seperator w-25 border-bottom border-1 border-white mb-4 ms-xl-1 m-auto"></div>
                  <p className="mb-4">
                    Expert infrastructure solutions for high-voltage electrical networks and turnkey EVCS deployments.
                  </p>
                  <ul className="list-unstyled contact-list">
                    <li className="mb-2">
                      <i className="fa fa-map-marker me-2"></i>
                      {Companydata[0].address}
                    </li>
                    <li className="mb-2">

                      <i className="fa fa-phone me-2 "></i>
                     {Companydata[0].phoneno}

                    </li>

                    <li>

                      <i className="fa fa-envelope-o me-2 "></i>
                     {Companydata[0].emailid}

                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>

          {/* ===== Copyright ===== */}
          <div className="copyright px-6 py-4 rounded2 text-center position-relative">
            <div className="overlay bg-white rounded2"></div>
            <div className="copyright-inner position-relative">
              <div className="row gy-4">

                <div className="col-lg-6 ">
                  <ul className="list-unstyled d-flex flex-wrap  justify-content-center justify-content-lg-start">
                    <li className="me-4 small ">Terms of Conditions</li>
                    <li className="me-4 small">Privacy Policy</li>
                    <li className="small">Cookie Policy</li>
                  </ul>
                </div>

                <div className="col-lg-6">
                  <div className="copyright-info text-lg-end">
                    <p className="small mb-0">
                      2022 Denial Enterprise All rights reserved.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <BackToTop />
        </div>
      </div>
    </footer>
        </>
  );
}

export default Footer;
